var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.textComponent,{tag:"component",attrs:{"bold":_vm.bold,"adaptive":_vm.adaptive,"tag":_vm.tag}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }